module.exports = __webpack_public_path__ + "img/joushinji_logo_separate.42745861.png";